export const REF_QUERY_KEY = 'ref';
export const REF_LOGIN_VALUE = 'login';

export const isRedirectingFromLogin = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(REF_QUERY_KEY) === REF_LOGIN_VALUE;
  // clear the query param to prevent issues with future logins during the same session
  window.history.replaceState({}, document.title, window.location.pathname);
  return value;
};

export const appendLoginRedirectParam = (url: string) => {
  const urlObj = new URL(url, window.location.origin);
  urlObj.searchParams.set(REF_QUERY_KEY, REF_LOGIN_VALUE);
  return urlObj.toString();
};
